<template>
  <div ref="swiper" class="swiper-container">
    <div class="swiper-wrapper"
         :class="{isDragging}"
         :style="{left: slidePosition}"
         ref="slides"
         @mousedown="onHandleStart"
         @touchstart="onHandleStart"
    >
      <div class="list1 swiper-slide" :class="{ active: currentIndex === 0, [$i18n.locale]: true }">
        <div class="swiper-content--wrap">
          <figure class="img--wrap"></figure>
          <div class="desc--wrap">
            <p class="title">{{ $t('page.registration.guide.preview.list1.title') }}</p>
            <ul>
              <li class="desc" v-html="$t('page.registration.guide.preview.list1.desc')"></li>
            </ul>
            <a class="match-select-guide learn-more" :href="matchGuideLink" target="_blank" v-html="$t('page.registration.guide.learnMore')"></a>
          </div>
        </div>
      </div>
      <div v-if="false" class="list2" :class="{ active: currentIndex === 1, [$i18n.locale]: true }"><!-- 스펙아웃 대상 : 오픈 베타 이후 -->
        <div class="swiper-content--wrap">
          <div class="img--wrap">
            <figure>
              <img src="../../assets/img/page/regi_guide_4-2-1.png" alt="registration guide image">
              <figcaption v-html="$t('page.registration.guide.preview.list2.figCaption.before')"></figcaption>
            </figure>
            <i class="icon icon--arrow-gray-size20"></i>
            <figure>
              <img src="../../assets/img/page/regi_guide_4-2-2.png" alt="registration guide image">
              <figcaption v-html="$t('page.registration.guide.preview.list2.figCaption.after')"></figcaption>
            </figure>
          </div>
          <div class="desc--wrap">
            <p class="title">{{ $t('page.registration.guide.preview.list2.title') }}</p>
            <ul>
              <li class="desc" v-html="$t('page.registration.guide.preview.list2.desc')"></li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="false" class="list3" :class="{ active: currentIndex === 2, [$i18n.locale]: true }"><!-- 스펙아웃 대상 : 오픈 베타 이후 -->
        <div class="swiper-content--wrap">
          <div class="img--wrap">
            <figure>
              <img src="../../assets/img/page/regi_guide_4-3-1.png" alt="registration guide image">
            </figure>
            <i class="icon icon--arrow-gray-size20"></i>
            <figure>
              <img src="../../assets/img/page/regi_guide_4-3-2.png" alt="registration guide image">
            </figure>
          </div>
          <p class="figure-caption" v-html="$t('page.registration.guide.preview.list3.figCaption')"></p>
          <div class="desc--wrap">
            <p class="title">{{ $t('page.registration.guide.preview.list3.title') }}</p>
            <ul>
              <li class="desc" v-html="$t('page.registration.guide.preview.list3.desc')"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-show="false" class="swiper-pagination" slot="pagination" ref="pagination">
      <template v-for="index in slides.length">
        <span
          :key="index"
          class="dot"
          :class="{ active: index - 1 === currentIndex }"
          @click="goToSlide(index - 1)"
        ></span>
      </template>
    </div>
    <div v-show="false"
         ref="swiperLeft"
         class="swiper-button-prev icon icon--prev-white-size20"
         @click="prevSlide"
    ></div>
    <div v-show="false"
         ref="swiperRight"
         class="swiper-button-next icon icon--prev-white-size20"
         @click="nextSlide"
    ></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      slides: [],
      currentIndex: 0,
      isDragging: false,
      startX: 0,
      endX: 0,
      dragOffset: 0,
      slidePosition: null
    }
  },
  computed: {
    matchGuideLink () {
      switch (this.$i18n.locale) {
        case 'ko':
          return 'https://forum.beusable.net/ko/solomon/post/738'
        case 'en':
          return 'https://forum.beusable.net/en/solomon/post/1437'
        case 'ja':
          return 'https://forum.beusable.net/ja/solomon/post/1630'
        default:
          return null
      }
    }
  },
  methods: {
    nextSlide () {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length
      this.getTransformStyle()
    },
    prevSlide () {
      this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length
      this.getTransformStyle()
    },
    goToSlide (index) {
      this.currentIndex = index
      this.getTransformStyle()
    },
    onHandleStart (event) {
      this.isDragging = true
      this.startX = event.touches ? event.touches[0].clientX : event.clientX
      this.dragOffset = 0
      if (this.isDragging) {
        window.addEventListener('mousemove', this.onHandleMove)
        window.addEventListener('mouseup', this.onHandleEnd)
      }
    },
    onHandleMove (event) {
      if (!this.isDragging) return

      const currentX = event.touches ? event.touches[0].clientX : event.clientX
      this.dragOffset = currentX - this.startX
      const dragTranslate = (this.dragOffset / 480) * 100
      const baseTranslate = -this.currentIndex * 100
      this.slidePosition = `${baseTranslate + dragTranslate}%`
    },
    onHandleEnd () {
      if (!this.isDragging) return

      if (this.dragOffset > 50) {
        this.prevSlide()
      } else if (this.dragOffset < -50) {
        this.nextSlide()
      } else {
        this.resetDrag()
      }
      this.isDragging = false
      this.startX = 0
      this.endX = 0
      this.getTransformStyle()
    },
    getTransformStyle () {
      const baseTranslate = -this.currentIndex * 100
      const dragTranslate = (this.endX / 480) * 100
      this.slidePosition = `${baseTranslate + dragTranslate}%`
    },
    resetDrag () {
      this.dragOffset = 0
    }
  }
}
</script>
